import React from 'react'
import styled from '@emotion/styled'
import moment from 'moment'
import { Button, Tag, Icon, Popconfirm } from 'antd'
import { colors } from 'style/theme'
import { navigate } from '@reach/router'
import { RUN_SCAN_PERMISSION, MANAGE_SCAN_PERMISSION } from 'utils/constants'
import TimeAgo from 'react-timeago'
import { toLocalTime } from 'utils/formatters'
import ScanParametersModal from '../../Scans/components/ScanParametersModal';
import {usePayment} from 'context/payment-context';

const StyledName = styled.span({
  color: colors.brandTextLight,
  fontWeight: 800,
  fontSize: '1rem'
})

const TypeTag = styled(Tag)({
  textTransform: 'uppercase',
  fontSize: '0.6rem',
  backgroundColor: colors.brandButton,
  color: 'white'
})

const StyledOwner = styled.span({
  color: colors.brandText,
  fontSize: '1rem'
})

const StyledScans = styled.span({
  color: colors.brand,
  fontSize: '1rem',
  fontWeight: 800,
})

const StyledDate = styled.span({
  color: colors.brandTextLight,
  fontSize: '0.8rem'
})

const Play = styled(Icon)({
  color: colors.brandGray,
  fontSize: '2.2rem'
})

function ScanSettingsListColumns({ handleStartScan, handleDeleteScan, user, isParametersModalVisible, setParametersModalVisible, errors, startData }) {
	const {setPaymentModalOpen, isTrialAccount, isCanceledPayg} = usePayment();

  return [
    {
      dataIndex: 'id',
      width: 50,
      render(id, record) {
        let isAllowed = user.permissions.filter(p => RUN_SCAN_PERMISSION.includes(p))
        let isEnabledParameters = record && record.enable_parameters;
        return (
          !!isAllowed.length && (
            <>
              {
                isEnabledParameters 
                ?
                  <ScanParametersModal 
                      scanCreateDataSuccess={startData}
                      error={errors}
                      scanSettings={false} 
                      setOpenModal={setParametersModalVisible} 
                      openModal={isParametersModalVisible} 
                      scanSettingsId={record && record.id}
                      onRun={(e, baseAddress, uRemediateProfile) => handleStartScan({ id: record.id, name: record.name }, baseAddress, uRemediateProfile)}
                  >
                    <Play type="play-circle" onClick={() => {
                      if (isTrialAccount || isCanceledPayg) {
                        setPaymentModalOpen(true);
                        return;
                      }
                      setParametersModalVisible({isVisible: true, id: record.id})}} />
                  </ScanParametersModal>
                :
                <Play type="play-circle" onClick={e => {
                  if (isTrialAccount || isCanceledPayg) {
                    setPaymentModalOpen(true);
                    return;
                  }
                  handleStartScan({ id: record.id, name: record.name })}} />
              }
            </>
          )
        )
      }
    },
    {
      title: 'NAME',
      dataIndex: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
      render(name) {
        return <StyledName>{name}</StyledName>
      }
    },
    {
      title: 'TYPE',
      dataIndex: 'type',
      sorter: (a, b) => a.type.localeCompare(b.type),
      render(type) {
        return <TypeTag>{type}</TypeTag>
      }
    },
    {
      title: 'SCANS',
      dataIndex: 'scans',
      sorter: (a, b) => a.scans - b.scans,
      render(scans) {
        return <StyledScans>{scans}</StyledScans>
      }
    },
    {
      title: 'PAGE COUNT',
      dataIndex: 'count',
      sorter: (a, b) => a.scans - b.scans,
      render(count) {
        return <StyledScans>{count}</StyledScans>
      }
    },
    {
      title: 'OWNER',
      dataIndex: 'owner',
      sorter: (a, b) => a.owner.localeCompare(b.owner),
      render(owner) {
        return <StyledOwner>{owner}</StyledOwner>
      }
    },
    {
      title: 'DATE',
      dataIndex: 'create_date',
      sorter: (a, b) => moment(a.create_date).unix() - moment(b.create_date).unix(),
      render(create_date) {
        let now = moment()
        let created = moment(toLocalTime(create_date))
        let isNow = now.diff(created, 'minutes') < 1
        return (
          <StyledDate>{isNow ? <span>now</span> : <TimeAgo date={toLocalTime(create_date)} live={false} />}</StyledDate>
        )
      }
    },
    {
      dataIndex: 'view_id',
      width: 130,
      render(id, record) {
        return (
          <Button
            data-id="viewScans"
            icon="eye"
            type="link"
            block
            onClick={() => navigate(`/scan-settings/${record.id}/scans/`)}
          >
            VIEW SCANS
          </Button>
        )
      }
    },
    {
      dataIndex: 'delete_id',
      width: 80,
      render(id, record) {
        let isAllowed = user.permissions.filter(p => MANAGE_SCAN_PERMISSION.includes(p))
        return (
          !!isAllowed.length && (
            <Popconfirm
              title="Are you sure you want to delete?"
              placement="leftBottom"
              okText="Yes"
              cancelText="No"
              onConfirm={e => handleDeleteScan(e, { id: record.id, name: record.name })}
            >
              <Button data-id="deleteScanSettings" icon="delete" type="link" block></Button>
            </Popconfirm>
          )
        )
      }
    }
  ]
}

export default ScanSettingsListColumns
